<template>
    <div>
        <v-app-bar flat height="110" color="#F5F5F5">

            <v-toolbar-title>
                <router-link to="/">
                <v-img
                src="https://pipemein.com/files/pipemein/image/favicon.png"
                width="250"
                ></v-img></router-link>                  
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="mr-2" icon style="width:40px; height: 40px;color:white;background:#ff5722;">
                <v-icon style="font-size: 16px;">
                    fas fa-shopping-cart
                </v-icon>
            </v-btn>
        </v-app-bar>
        <v-app-bar color="#003B63" flat>
            <v-btn text icon small @click="menu = !menu"
        style="margin:0 auto;display:block;color:orange" class="my-2 hidden-md-and-up">
            <i class="fas fa-bars"></i>
        </v-btn>
                <v-btn class="px-5 mx-1 hidden-md-and-down" 
                style="text-transform:none;font-weight:600"
                v-for="(a,i) in b" :key="i" :to="a.link" text color="orange">
                    {{a.name}}
                </v-btn>
            <v-spacer></v-spacer>
            <div style="font-size:16px;" class="hidden-md-and-down white--text mt-2">
                <marquee>
                    <img src="https://pipemein.com/files/pipemein/image/flapUSA.png" width="16"/> 
                    | Made In USA
                </marquee>
            </div>
            <div style="font-size:16px;" class="hidden-md-and-up white--text mt-2">
                <marquee>
                    <img src="https://pipemein.com/files/pipemein/image/flapUSA.png" width="16"/> 
                    | Made In USA
                </marquee>
            </div>
            <v-btn v-if="usuario != null" color="error" @click="cerrarSesion()">Log Out</v-btn>
        </v-app-bar>
        <div flat class="white--text text-center" 
        style="
            background: #1680166c;
            border-left: solid green 5px;
            border-top: solid green 1px;
            border-bottom: solid green 1px;
            border-right: solid green 5px;
        ">
            <p class="text-center pt-3">
                <v-icon class="mx-1 white--text">fas fa-recycle</v-icon>
                <strong>
                    Made With Recycled Materials
                </strong>
            </p>
        </div>
        <v-navigation-drawer absolute v-model="menu" style="width:100%">
            <v-card flat color="white">
                <v-card-text>
                    <div style="background:white;margin-top:30px;">
            <router-link to="/" style="text-decoration:none;">
                <v-img src="https://pipemein.com/files/pipemein/image/favicon.png"
            style="width:250px;margin:0px auto;display:block;"
            ></v-img>
            </router-link>
            <p class="text-center" style="font-style:italic;cursor:context-menu;">
                Made In USA
            </p>
    
        </div>
                </v-card-text>

                <div @click="menu = !menu" style="text-align:center;font-size:12px;color:black;text-decoration:none;">
            <i class="fas fa-angle-left pr-1"></i>
            <span>Back</span>
        </div>
                <v-card-text class="mt-5">
                    <v-btn block text class="my-2"
                     style="background:none;border-radius:10px;font-weight:600;font-size:14px;color:#333"
                    v-for="(item, i) in b" :key="i" :to="item.link">
                        {{item.name}}
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-navigation-drawer>
    </div>
</template>

<style>
.alerts {
    color: white;
    background: #1680166c;
    border-left: solid #008000 5px;
    border-top: solid green 1px;
    border-bottom: solid green 1px;
    border-right: solid green 5px;
}
.submenu {
    margin:0 auto;
    display: block;
}
</style>

<script>
import { mapState, mapActions } from "vuex";
export default {
    

    data() {
        return {
            menu:false,
            b: [
                {name: 'Home', link: {name: 'home'}},
                {name: 'Towers/Power', link: {name: 'powers'}},
                {name: 'Tunnels/Cable', link: {name: 'tunnels'}},
                {name: 'Gallery', link: {name: 'gallery'}},
            ], appss: false
        }
    },
    computed: {
        ...mapState(['usuario'])
    },
    methods:{
        ...mapActions(['cerrarSesion'])
    }

    
}
</script>